import { useId } from 'react';

// The GakuShiori mark: a bookmark (shiori) with 学 on it. Same geometry as public/Assets/*.svg.
const BOOK = 'M24 14H76V102L50 84L24 102Z';
const GAKU =
  'M39.58 35.27Q38.62 32.88 36.95 30.71L40.47 29.19Q42.09 31.12 43.59 33.9L40.66 35.27H49.08Q48.99 35.07 48.91 34.88Q47.88 32.42 46.32 30.19L49.9 28.78Q51.59 30.86 52.94 33.75L49.4 35.27H55.65Q57.64 32.36 59.29 28.93L63.39 30.23Q61.79 32.88 59.92 35.27H66.76V42.42H62.7V38.54H37.21V42.42H33.18V35.27ZM52.51 49.5V50.93H68.04V54.35H52.51V61.86Q52.51 63.64 51.62 64.42Q50.7 65.22 48.23 65.22Q45.33 65.22 42.94 64.98L42.1 61.23Q45.83 61.64 47.28 61.64Q48.1 61.64 48.3 61.25Q48.45 60.95 48.45 60.38V54.35H31.96V50.93H48.45V47.96Q51.83 46.57 54.07 45.11H38.38V41.8H59.95L61.87 44.12Q56.63 47.46 52.51 49.5Z';

// drawn: chalk outline that draws itself on, then 学 is written in, then it holds still (class-code page).
// Otherwise the solid mark, as on the app icon (the rail).
export function Bookmark({ drawn = false, size = 32, className }: { drawn?: boolean; size?: number; className?: string }) {
  const id = useId().replace(/:/g, '');
  const h = (size * 114) / 100;
  if (!drawn)
    return (
      <svg className={className} width={size} height={h} viewBox="0 0 100 114" aria-hidden="true">
        <mask id={`k${id}`}>
          <rect width="100" height="114" fill="#fff" />
          <path d={GAKU} fill="#000" />
        </mask>
        <path d={BOOK} fill="currentColor" mask={`url(#k${id})`} />
      </svg>
    );
  return (
    <svg className={`bookmark-drawn${className ? ` ${className}` : ''}`} width={size} height={h} viewBox="0 0 100 114" aria-hidden="true">
      <filter id={`c${id}`} x="-10%" y="-10%" width="120%" height="120%">
        <feTurbulence type="fractalNoise" baseFrequency="1.3" numOctaves="2" seed="7" result="t" />
        <feDisplacementMap in="SourceGraphic" in2="t" scale="2.4" result="d" />
        <feColorMatrix in="t" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 -1.7 1.5" result="m" />
        <feComposite in="d" in2="m" operator="in" />
      </filter>
      <g filter={`url(#c${id})`} fill="none" stroke="var(--chalk)" strokeLinejoin="round" strokeLinecap="round">
        <path className="bm-outline" d="M24 14 L76 13 L77 102 L50.5 84 L23 103 Z" strokeWidth="4.6" pathLength={1} />
        <path className="bm-cord" d="M50 13 C 52 6, 58 3, 63 5 C 66 7, 66 11, 62 12" strokeWidth="2.6" pathLength={1} />
        <path className="bm-gaku" d={GAKU} fill="var(--ink)" stroke="none" />
      </g>
    </svg>
  );
}
